import { ValidatorFn } from '@angular/forms';
import { MethodCall } from '@angular/compiler';
import { MethodFn } from '@angular/core/src/reflection/types';
import { Function } from 'estree';

export interface GridColumn {
  field: string;
  header?: string;
  label?: string;
  typeConfig: ColumnFieldTypeConfiguration;
  visible?: boolean;
  editable?: boolean;
  sortable?: boolean;
  showlabel?: string;
  SecondField?: string;
  SecondFieldLabel?: string;
  IsDisabled?: boolean;
  InitValue?: string;
  CustomClass?: string;
}

export interface ColumnFieldTypeConfiguration {
  // column type
  type?: ColumnFieldType,
  getType?: (rowData: any) => ColumnFieldType;
  // field validation => custom validations and predefined validation
  validations?: FieldTypeValidation,
  requiredCustomVaildator?: boolean,
  filterbyRadio?: boolean;
  onclick?: Function;
  ///////// in case of type is 'dropdown' /////////
  lookupType?: any;
  FilteredLookupType?: any;

  FieldFilters?: string,
  listOptions?: any[];
  addingCustomHTML?: (rowData: any) => string;
  customHTML?: CustomHTML,
  ///////// in case of type is 'filteredDropdown' /////////
  // use it in filtered field
  filterByKey?: string;
  // use it in filtered field
  filterByField?: string;
  showIf?: string;
  showIfValue?: any;
  hideIf?: string;
  disableInEditMode?: boolean;
  // use it in primary field (in dropdown)
  dependantField?: string;
  ///////// in case of type is 'Mutliselect dropdown' /////////
  dataKey?: string;
  optionLabel?: string;
  optionKey?: string;
  isDeleted?: string;
  ///////// in case of type is 'date' or 'dateTime' /////////
  // To change display format
  dateFormat?: string;
  dateTimeFormat?: string;
  // max date property
  filterMaxFromDatePropertyName?: string;
  // min date property
  filterMinToDatePropertyName?: string;
  //datePickerOptions?: any;
  pattern?: string;
  //minDate?: Date,
  //maxDate?: Date,
  DateFieldToLink?: string;
  ///////// in case of type is 'Href' /////////
  urlKey?: string;
  ///////// in case of type is 'uploader' /////////
  minAttachments?: number;
  maxAttachments?: number;
  isAttachmentRequired?: boolean;
  documentConfigurationKey?: any;

  ///////// in case of type is 'Button' /////////
  ButtonAction?: (rowData: any) => void;
  ButtonStyle?: string;
  ConditionalButtonStyle?: (rowData: any) => string;
  ButtonTitle?: string;
  ///////// in case of type is 'Textarea' /////////
  rows?: number;
  columns?: number
  //Show in add Mode
  hideInAddMode?: boolean,
}

export interface FieldTypeValidation {
  validator?: ValidatorFn[],
  validatorFn?: ValidatorFn[]
}

export interface CustomValidationResult {
  [key: string]: CustomValidationErrorMessage;
}

export interface CustomValidationErrorMessage {
  errorMessage: string;
}

export enum ColumnFieldType {
  None = '',
  Number = 'number',
  Text = 'text',
  TextArea = 'textArea',
  Dropdown = 'dropdown',
  FilteredDropdown = 'filteredDropdown',
  Date = 'date',
  DateTime = 'dateTime',
  Uploader = 'uploader',
  Href = 'href',
  Button = 'Button',
  HTML = 'HTML',
  RadioButton = 'RadioButton',
  Mutliselect ='Mutliselect',
  Questions = 'Questions',
  TwoDropdown = 'TwoDropdown',
  FilteredURLDropdown = 'FilteredURLDropdown'
}
export interface CustomHTML {
  showCustomHtml: boolean;
  innerHtml: string;
}
